import { registerBlockType } from '@wordpress/blocks';
import { RichText } from '@wordpress/block-editor';
import './block-styles.css';

registerBlockType('custom-blocks/example-block', {
    title: 'Ejemplo de Bloque',
    icon: 'smiley',
    category: 'design',
    attributes: {
        content: {
            type: 'string',
            source: 'html',
            selector: 'p',
        },
    },
    edit: ({ attributes, setAttributes }) => {
        const { content } = attributes;
        return (
            <RichText
                tagName="p"
                className="custom-block-editor" // Clase para estilos de editor
                value={content}
                onChange={(newContent) => setAttributes({ content: newContent })}
            />
        );
    },
    save: ({ attributes }) => {
        return (
            <RichText.Content
                tagName="p"
                className="custom-block-frontend" // Clase para estilos del frontend
                value={attributes.content}
            />
        );
    }
});
